import React from "react";
import CustomModal from "../../../../../components/CustomModal";
import ErrorBoundary from "../../../../../components/ErrorBoundary";
import { useStatus } from "../../../../../hooks/StatusContext";
import { ITriagens } from "../types/types";
import Scheduling from "./Scheduling";
import HistoricSchedule from "./components/HistoricSchedule";
import { listTimeline } from "./components/HistoricSchedule/timeline";

// import { Container } from './styles';

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  onClear: () => void;
  onConfirm: () => void;
  selectedRow?: ITriagens;
}

const Create: React.FC<Props> = (props: Props) => {
  const { status } = useStatus();

  return (
      <CustomModal
        isScreenLg
        maxWidth="900px"
        onClose={props.onClear}
        header={<HistoricSchedule data={listTimeline} status={status} />}
      >
        <ErrorBoundary
          message="Erro ao carregar esta etapa da triagem."
          onReset={props.onClear}
        >
          <Scheduling onClose={props.onClear} />
        </ErrorBoundary>
      </CustomModal>
  );
};

export default Create;
